module.exports = __webpack_public_path__ + "img/资源99.6851e3f9.png";